import {useNavigate} from 'react-router-dom'
export function ButtonGoBack() {
    const navigate = useNavigate()

    return (
        <button
            type='button'
            onClick={() => navigate(-1)}
            className='btn btn-sm btn-secondary ms-2'
        >
            <i className='fas fa-arrow-alt-circle-left'></i>
            Voltar
        </button>
    )
}
